<script>
import isUndefined from 'lodash/isUndefined';

import './stylesheets/components/FloatLabel';

export default {
  props: {
    placeholder: String,
    fullWidth: [String, Boolean],
    value: [String, Number, Boolean, Date, Object],
    hideLabel: [String, Boolean],
    textarea: [String, Boolean],
    large: [String, Boolean],
    largeOnDesktop: [String, Boolean],
    type: String,
  },
  computed: {
    valueAsString() {
      return !isUndefined(this.value) && this.value !== null && this.value.toString();
    },
    classes() {
      return {
        'floatl--full-width': this.fullWidth,
        'floatl--active': this.valueAsString,
        'floatl--large': this.large,
        'floatl--large-on-desktop': this.largeOnDesktop,
        'floatl--search': this.type === 'search',
      };
    },
  },
  methods: {
    handleClick(e) {
      e.currentTarget.previousElementSibling.focus();
    },
  },
};
</script>

<template lang='pug'>
.floatl(:class='classes')
  slot
  .floatl__label.select-none(
    v-if='!hideLabel',
    :class='{ "floatl__label--textarea": textarea }',
    @click='handleClick',
  ) {{placeholder}}
  .floatl__bg.top-0.left-0.w-full.h-full.absolute
</template>